export enum ZoomLevel {
  Level0 = 1.0,
  Level1 = 0.6,
  Level2 = 0.4,
  Level3 = 0.2,
}
